import {
  ICdicCoupon,
  ICoupon,
  ICouponFamily,
  ICouponFamilySearch,
  ICouponProgram,
  ICouponSearch,
  ICouponService,
  IExportStatusCoupon,
  IFormExportValues,
  ResendParam,
} from "@interfaces";
import axiosClient from "./axiosClient";

export const couponApi = {
  coupons: (params: ICouponSearch) => {
    const url = "coupon/family/get";
    return axiosClient.get(url, { params });
  },
  coupon: (params: ICouponFamilySearch, id: string) => {
    const url = `/coupon/family/get/${id}`;
    return axiosClient.get(url, { params });
  },
  create: (params: ICoupon) => {
    const url = `/coupon/family/create`;
    return axiosClient.post(url, params);
  },
  generate: (params: ICoupon) => {
    const url = `/coupon/generate`;
    return axiosClient.post(url, params);
  },
  generateCdic: (params: ICdicCoupon) => {
    const url = `/cdic-coupon`;
    return axiosClient.post(url, params);
  },
  searchProgram: (params: string) => {
    const url = `/coupon/autocomplete/program/${params}`;
    return axiosClient.get(url);
  },
  searchServiceName: (params: string) => {
    const url = `/coupon/autocomplete/service/${params}`;
    return axiosClient.get(url);
  },
  searchFamilyByService: (params: string) => {
    const url = `/coupon/family/search/${params}`;
    return axiosClient.get(url);
  },
  redeemCoupon: (params: ICouponSearch) => {
    const url = `/coupon/redemeed-info`;
    return axiosClient.get(url, { params });
  },
  exportExcel: (params: ICouponSearch) => {
    const url = `/coupon/export-redemeed-info`;
    return axiosClient.post(url, params);
  },
  exportActiveExcel: (id: string, params: ICouponSearch) => {
    const url = `/coupon/export-active-info/${id}`;
    return axiosClient.post(url, params);
  },
  updateStatus: (params: ICouponFamily, id: string) => {
    const url = `/coupon/update/couponStatus/${id}`;
    return axiosClient.put(url, params);
  },
  updateFamily: (params: ICoupon, id: string) => {
    const url = `/coupon/family/update/${id}`;
    return axiosClient.put(url, params);
  },
  resendSms: (params: ResendParam) => {
    const url = `/coupon/resend-code`;
    return axiosClient.post(url, params);
  },
  cdicCoupons: (id: string,params: ICouponSearch) => {
    const url = `/cdic-coupon/program/${id}`;
    return axiosClient.get(url, { params });
  },
  updateCdicCoupons: (params: ICdicCoupon, id: string) => {
    const url = `/cdic-coupon/update/${id}`;
    return axiosClient.patch(url, params);
  },
  redeemedCdicCoupons: (params: ICouponSearch) => {
    const url = `/cdic-coupon/redeemed-coupons-info`;
    return axiosClient.get(url, { params });
  },
  resendSmsCdic: (params: ResendParam) => {
    const url = `/cdic-coupon/resend-code`;
    return axiosClient.post(url, params);
  },
  exportCdicExcel: (params: ICouponSearch) => {
    const url = `/cdic-coupon/export-redemeed-info`;
    return axiosClient.post(url, params);
  },
  exportActiveCdicExcel: (id: string, params: ICouponSearch) => {
    const url = `/cdic-coupon/export-active-info/${id}`;
    return axiosClient.post(url, params);
  },
  exportStatusCdicExcel: (id: string, params: IExportStatusCoupon) => {
    const url = `/cdic-coupon/export-status-info/${id}`;
    return axiosClient.post(url, params);
  },
  getProgramList: (params: ICouponSearch) => {
    const url = `/cdic-program`;
    return axiosClient.get(url, { params });
  },
  getProgram: (id: string) => {
    const url = `/cdic-program/${id}`;
    return axiosClient.get(url);
  },
  createProgram: (params: ICouponProgram) => {
    const url = `/cdic-program`;
    return axiosClient.post(url, params);
  },
  updateProgram: (id: string, params: ICouponProgram) => {
    const url = `/cdic-program/${id}`;
    return axiosClient.patch(url, params);
  },
  searchProgramName: () => {
    const url = `/cdic-program/active/program-names`;
    return axiosClient.get(url);
  },
  createService: (params: ICouponService) => {
    const url = `/service-name`;
    return axiosClient.post(url, params);
  },
  searchServiceNames: () => {
    const url = `/service-name`;
    return axiosClient.get(url);
  },
  deleteService: (id: string) => {
    const url = `/service-name/${id}`;
    return axiosClient.delete(url);
  },
  exportCoupons: (params: IFormExportValues) => {
    const url = `/coupon/export-coupons-data`;
    return axiosClient.post(url, params);
  }
};
